
import React from "react";
import { ImageWithFallbackProps, ImageWithFallbackState } from "../../../utils/types";
export class ImageSidebarWithFallback extends React.Component<
  ImageWithFallbackProps,
  ImageWithFallbackState
> {
  state = {
    errored: false,
    id: "",
  };

  handleError = (event: React.SyntheticEvent<HTMLImageElement>) => {
    this.setState({ errored: true, id: this.props.dataid });
  };

  render() {
    if (this.state.errored) {
      return (
        <>
          <div id="blank" style={{
            width: '30px',
            display: 'inline-block',
            marginRight: '10px',
            marginLeft: '5px'
          }}></div>
          {this.props.showTitle && (
            <span id="showTitle" className={this.props.className} title={this.props.title}>
              {this.props.title}
            </span>
          )}
        </>
      );
    } else {
      return (
        <>
          <img
            id={this.props.dataid}
            data-id={this.props.dataid}
            alt={this.props.title}
            title={this.props.title}
            src={this.props.src}
            onError={this.handleError}
            style={this.props.style}
          />
          {this.props.showTitle && (
            <span id="showTitle" className={this.props.className} title={this.props.title}>
              {this.props.title}
            </span>
          )}
        </>
      );
    }

  }
}